import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form'
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getFiscalEmbarque, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import CalendarioDisponibilidadeVeiculo from './CalendarioDisponibilidadeVeiculo';
import buscarDisponibilidadesVeiculo from '../../actions/disponibilidade-veiculo/buscarDisponibilidadesVeiculo';
import selecionarDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/selecionarDisponibilidadeVeiculo';
import { showSuccessMsg } from '../../util/messagesUtil';
import excluirDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/excluirDisponibilidadeVeiculo';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import qs from 'qs';

const ModalConfirmacaoExclusaoDisponibilidadeVeiculo = ({excluir, limpar}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoDisponibilidadeVeiculo" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir Calendário Disponibilidade selecionado?</p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal" 
                            onClick={() => limpar()}
                            >Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);


export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col">Período</div>
            <div className="col">Ativo/Inativo</div>
            <div className="col">Categorias</div>
            <div className="col-sm-2 d-flex justify-content-center">Ações</div>
        </div>
    </div>
);

export class PainelGerenciarCalendariosDisponibilidadeVeiculo extends Component {

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros.veiculo) {
            this.props.selecionarDisponibilidadeVeiculo(null);
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarDisponibilidadesVeiculo(this.props.empresaSelecionada.id, parametros.veiculo);
            }
        } else {
            this.props.history.push('/painel-calendario-disponibilidade-veiculo');
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarDisponibilidadesVeiculo(this.props.empresaSelecionada.id);
            }
        }
    }

    excluir() {
        const veiculoId = this.props.disponibilidadeVeiculoSelecionado.veiculo.id;
        this.props.excluirDisponibilidadeVeiculo(this.props.disponibilidadeVeiculoSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('O calendário foi excluído com sucesso.');
                this.limparSelecaoDisponibilidadeVeiculo();
                this.props.buscarDisponibilidadesVeiculo(this.props.empresaSelecionada.id, veiculoId);
            });        
    }

    limparSelecaoDisponibilidadeVeiculo() {
        this.props.selecionarDisponibilidadeVeiculo(null);
    }

    exibirTabelaCalendariosDisponibilidadeVeiculo() {
        return (<div className="col-12 conteudo-internas">
            {this.props.disponibilidadesVeiculo.length != 0 && <CabecalhoTabela />}
            <div className="lista-table">
                {this.exibirCalendariosDisponibilidadesVeiculo()}
            </div>
        </div>
        )
    }

    exibirCalendariosDisponibilidadesVeiculo() {
        if (this.props.disponibilidadesVeiculo.length == 0) {
            return <div>Nenhum Calendário disponível.</div>;
        }

        return this.props.disponibilidadesVeiculo.map(it =>
            <CalendarioDisponibilidadeVeiculo  key={`disponibilidade-veiculo-${it.id}`} disponibilidadeVeiculo={it} /> );
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoCalendario() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                <div className="row col-md-12 mb-4">
                    <div className="row col-md-4">
                        <button className="btn btn-laranja" 
                        onClick={() => this.props.history.push('/painel-cadastro-calendario-disponibilidade-veiculo')}>
                            Criar Calendário
                        </button>
                    </div>
                </div>
            </Autorizacao>)
    }

    retornaNomeVeiculo() {
        return this.props.disponibilidadesVeiculo && this.props.disponibilidadesVeiculo.length > 0
            && this.props.disponibilidadesVeiculo[0].veiculo && this.props.disponibilidadesVeiculo[0].veiculo.descricao
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                <div>
                    <div className='col-md-12'>
                        <Titulo texto={`Calendário Disponibilidade Veículo ${this.retornaNomeVeiculo()}`} urlRetorno="/painel-calendario-disponibilidade-veiculo" />
                        {this.exibirBotaoNovoCalendario()}
                        {this.exibirTabelaCalendariosDisponibilidadeVeiculo()}
                    </div>

                </div>
                <ModalConfirmacaoExclusaoDisponibilidadeVeiculo excluir={this.excluir.bind(this)} limpar={this.limparSelecaoDisponibilidadeVeiculo.bind(this)}/>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => (
    {
        veiculos: state.veiculos.veiculos,
        empresaSelecionada: state.empresaSelecionada,
        disponibilidadesVeiculo: state.disponibilidadesVeiculo,
        disponibilidadeVeiculoSelecionado: state.disponibilidadeVeiculoSelecionado
    });


export default withRouter(connect(mapStateToProps, {
    buscarDisponibilidadesVeiculo,
    selecionarDisponibilidadeVeiculo,
    excluirDisponibilidadeVeiculo
})(reduxForm({
    form: 'formularioCalendarioDisponibilidadeVeiculo'
})(PainelGerenciarCalendariosDisponibilidadeVeiculo)))